import React from 'react';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import Empty from '../../../Components/Empty';
import ProductItem from './ProductItem';
import ArticleItem from './ArticleItem';
import config from '../../../../data.json';
import * as BuildUtil from '../../../Utils/BuildUtil';

function ProductGrid(props) {
  const {products, onItemClick, prefixPath} = props;
  const [categroies] = useOutlet('categories');
  const [articleCategories] = useOutlet('articleCategories');
  const [dimension] = useOutlet('dimension');
  const mobile = dimension.rwd === 'mobile';

  if (products.length <= 0) {
    return <Empty />;
  }

  if (
    prefixPath.indexOf('products') >= 0 ||
    prefixPath.indexOf('sales-event') >= 0
  ) {
    return (
      <ProductGridWrapper mobile={mobile} className="ProductGrid">
        {products.map((product, i) => {
          if (categroies.meta_data.item_ui_type === 'type1') {
            return (
              <ProductItem
                key={product.id}
                mobile={mobile}
                product={product}
                onClick={(evt) => onItemClick(product, evt)}
              />
            );
          }

          return (
            <ProductItem
              key={product.id}
              mobile={mobile}
              product={product}
              onClick={(evt) => onItemClick(product, evt)}
            />
          );
        })}
      </ProductGridWrapper>
    );
  } else if (prefixPath.indexOf('articles') >= 0) {
    return (
      <ArticleGridWrapper mobile={mobile} className="ArticleGrid">
        {products.map((product, i) => {
          const prebuilt = config.allowBuildAllArticles;
          const url = prebuilt
            ? BuildUtil.getArticlePath(product)
            : `/article?id=${product.id}`;
          const props = {
            item: product,
            url,
            prebuilt,
          };

          if (articleCategories.meta_data.item_ui_type === 'type1') {
            return <ArticleItem key={i} {...props} />;
          }

          return <ArticleItem key={i} {...props} />;
        })}
      </ArticleGridWrapper>
    );
  }
}

const ProductGridWrapper = styled.div`
  max-width: var(--contentMaxWidth);
  padding: 30px 0px;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;

  @media screen and (max-width: 1200px) {
    padding: 30px 50px;
  }
  @media screen and (max-width: 768px) {
    padding: 30px 20px;
    grid-template-columns: repeat(2, minmax(90px, 1fr));
  }
`;

const ArticleGridWrapper = styled.div`
  max-width: var(--contentMaxWidth);
  padding: 30px 0px;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;

  @media screen and (max-width: 1200px) {
    padding: 30px 50px;
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: 768px) {
    padding: 30px 20px;
    grid-template-columns: repeat(1, 1fr);
  }
`;

export default ProductGrid;
